export default __webpack_public_path__ + "static/images/NT_welcome_Logo.png";